import { computed } from 'vue'
import { useGameStore } from '../stores/game'
import { toNumber } from '../utils/betLimits'

export function useBetSettings() {
  const gameStore = useGameStore()

  const betSettings = computed(() => gameStore.getBetSettings)

  const currencySymbol = computed(() => betSettings.value?.currency_symbol)
  const currencyCode = computed(() => betSettings.value?.currency_code)
  const betMin = computed(() => toNumber(betSettings.value?.bet_min, 1))
  const betMax = computed(() => toNumber(betSettings.value?.bet_max, 10000))
  const payoutMax = computed(() => toNumber(betSettings.value?.payout_max, 0))
  const betDefault = computed(() => toNumber(betSettings.value?.bet_default, 5))
  const betLimit = computed(() => toNumber(betSettings.value?.bet_limit, 0))
  const allowDecimals = computed(() => betSettings.value?.allow_decimals || false)
  const stakeOptions = computed(() => {
    if (betSettings.value?.bet_options?.stakes && Array.isArray(betSettings.value.bet_options.stakes)) {
      return betSettings.value.bet_options.stakes
    }
    if (betSettings.value?.bet_amount_values && Array.isArray(betSettings.value.bet_amount_values)) {
      return betSettings.value.bet_amount_values
    }
    return [1, 2, 5, 10, 25, 50]
  })

  const isLoaded = computed(() => betSettings.value !== null)
  const hasError = computed(() => gameStore.error !== null)

  return {
    betSettings,
    currencySymbol,
    currencyCode,
    betMin,
    betMax,
    payoutMax,
    betLimit,
    betDefault,
    allowDecimals,
    stakeOptions,
    isLoaded,
    hasError
  }
}
